/**
 * Build sizes on a clothing scale.
 *
 * The number is the width of the build in studs: the model is fitted to that
 * many studs across, so a bigger size buys a finer voxel grid and more of
 * the source model's detail survives the conversion.
 */
export interface BuildSize {
  id: string;
  /** The clothing-size label — XS to XL, the same in every language */
  label: string;
  /** The build's width in studs */
  studs: number;
}

export const BUILD_SIZES: BuildSize[] = [
  { id: "xs", label: "XS", studs: 12 },
  { id: "s", label: "S", studs: 18 },
  { id: "m", label: "M", studs: 24 },
  { id: "l", label: "L", studs: 32 },
  { id: "xl", label: "XL", studs: 48 },
];

/** The size whose stud count is nearest the given value. */
export const sizeForStuds = (studs: number): BuildSize =>
  BUILD_SIZES.reduce((best, size) =>
    Math.abs(size.studs - studs) < Math.abs(best.studs - studs) ? size : best,
  BUILD_SIZES[0]);
